// Copyright (c) 2022 Deere & Company

import actions from '../../../../sharedmodules/actions-list';

export const updateTransferComment = (transfer) => (dispatch) => dispatch({
    data: transfer,
    type: actions.UPDATE_TRANSFER_COMMENT_SUCCESS,
});
